import * as React from 'react'
import './Tabs.scss'

const Tab = ({active, className = "", ...props}) => (
  <div {...props} className={`Tab ${active ? 'active' : ''} ${className}`}/>
)

export default Tab